import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { PasswordModule } from 'primeng/password';

import { COMMON_STANDALONE_IMPORTS } from '@shared/common-imports';
import { FormErrorComponent } from '@shared/components';
import { RequiredLabelDirective } from '@shared/directives';
import { FormGroupOf, ForgotPasswordRequest } from '@shared/models';
import { AuthHttpService, ToastsService } from '@shared/services';
import { FormGenerator, FormGroupExtension } from '@shared/utils';

import { AuthCardComponent } from '../auth-card/auth-card.component';

@Component({
  templateUrl: './forgot-password.component.html',
  imports: [
    ...COMMON_STANDALONE_IMPORTS,
    TranslateModule,
    FormErrorComponent,
    PasswordModule,
    ButtonModule,
    RequiredLabelDirective,
    AuthCardComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ForgotPasswordComponent {
  forgotPasswordComponentLoader = 'forgotPasswordComponentLoader';

  editForm: FormGroup<FormGroupOf<ForgotPasswordRequest>> = FormGenerator.initForgotPasswordForm();

  constructor(
    private authService: AuthHttpService,
    public toastsService: ToastsService,
    private router: Router,
    private translate: TranslateService
  ) {}

  onSubmit(): void {
    if (FormGroupExtension.hasAnyValidationError(this.editForm)) {
      FormGroupExtension.markFormAsDirtyAndTouched(this.editForm);
      this.translate.instant('error.invalidForm');
      return;
    }
    this.authService.forgotPassword(this.forgotPasswordComponentLoader, this.editForm.getRawValue()).subscribe({
      next: () => {
        this.toastsService.showSuccess(this.translate.instant('auth.forgotPassword.forgotPasswordSendToast'));
        this.router.navigate(['auth', 'reset-password'], { queryParams: { email: this.editForm.value.email } });
      },
      error: (error) => this.toastsService.showError(error),
    });
  }
}
